import { createReducer, on } from '@ngrx/store';

import * as fromModuleModels from '../../models';
import { CustomerContactsActions } from '../actions';
import { ErrorsObject } from '../../../shared/utilities/error-utility.utility';
import { getAndHandleBackendErrors } from '../../../shared/utilities/reducer.utility';
import { UserRoleActions } from '../../../application-state/store/actions';

export interface State {
  entities: { [iri: string]: fromModuleModels.CustomerContact };
  errors: ErrorsObject;
  loading: boolean;
  loaded: boolean;
}

const initialState = {
  entities: {},
  errors: {},
  loading: false,
  loaded: false
};

export const reducer = createReducer(
  initialState,
  on(
    CustomerContactsActions.CreateCustomerContact,
    CustomerContactsActions.ReadCustomerContacts,
    CustomerContactsActions.ReadCustomerContact,
    CustomerContactsActions.UpdateCustomerContact,
    CustomerContactsActions.DeleteCustomerContact,
    state => {
      return {
        ...state,
        loading: true
      };
    }
  ),
  on(
    CustomerContactsActions.CreateCustomerContactSuccess,
    CustomerContactsActions.UpdateCustomerContactSuccess,
    CustomerContactsActions.ReadCustomerContactSuccess,
    (state, { response }) => {
      const entities = {
        ...state.entities,
        [response['@id']]: response
      };

      return {
        ...state,
        entities,
        loading: false
      };
    }
  ),
  on(
    CustomerContactsActions.ReadCustomerContactsSuccess,
    (state, { response }) => {
      const commentTags = response['hydra:member'];
      const entities = commentTags.reduce(
        (
          entities: { [iri: string]: fromModuleModels.CustomerContact },
          contact
        ) => {
          return {
            ...entities,
            [contact['@id']]: contact
          };
        },
        { ...state.entities }
      );

      return {
        ...state,
        entities,
        errors: {},
        loading: false
      };
    }
  ),
  on(CustomerContactsActions.DeleteCustomerContactSuccess, (state, { iri }) => {
    // @ts-ignore
    const { [iri]: removedItem, ...entities } = state.entities;

    return {
      ...state,
      entities,
      errors: {},
      loading: false
    };
  }),
  on(
    CustomerContactsActions.ReadCustomerContactsFail,
    CustomerContactsActions.CreateCustomerContactFail,
    CustomerContactsActions.UpdateCustomerContactFail,
    CustomerContactsActions.DeleteCustomerContactFail,
    CustomerContactsActions.ReadCustomerContactsFail,
    (state, { type, response }) => {
      return {
        ...state,
        errors: getAndHandleBackendErrors(response),
        loading: false
      };
    }
  ),
  on(UserRoleActions.UserRoleCheckFail, state => ({ ...state, loading: false }))
);
